import { render, staticRenderFns } from "./MedicineAdd.vue?vue&type=template&id=4149fcd6&scoped=true"
import script from "./MedicineAdd.vue?vue&type=script&lang=js"
export * from "./MedicineAdd.vue?vue&type=script&lang=js"
import style0 from "./MedicineAdd.vue?vue&type=style&index=0&id=4149fcd6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4149fcd6",
  null
  
)

export default component.exports